/* eslint-disable no-console */
import {Flex} from 'antd';
import React from 'react';

import {convertPxToRem} from '../../../../utils/commonFunctions';

const CountBoxSingle: React.FC<{
  title: string;
  image: string;
  value: {total: string; value1: string; value2: string};
  text: {totalUnit: string; label1: string; label2: string};
  isCost?: boolean;
}> = ({
  title,
  image,
  value: {total, value1, value2},
  text: {totalUnit, label1, label2},
  isCost = false
}) => {
  return (
    <Flex
      style={{
        padding: '1rem',
        border: '0.03125rem dashed #707070',
        gap: '15%',
        borderRadius: '0.5rem'
      }}
      flex={1}
    >
      <Flex
        gap="1rem"
        style={{
          padding: '0.5rem',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <img
          src={image}
          style={{width: convertPxToRem(63), height: convertPxToRem(63)}}
        />
        <Flex vertical={true}>
          <div
            style={{
              font: 'normal normal 600 12px/15px Montserrat',
              color: '#99B1C7'
            }}
          >
            {title}
          </div>
          <div
            style={{
              font: 'normal normal 600 24px/29px Montserrat',
              color: '#677489'
            }}
          >
            {isCost ? (
              <>
                <span>{` ${totalUnit ?? ''} `}</span>
                {total ?? ''}
              </>
            ) : (
              <>
                {total ?? ''}
                <span>{` ${totalUnit ?? ''}`}</span>
              </>
            )}
          </div>
        </Flex>
      </Flex>
      <Flex
        vertical={true}
        gap="1rem"
        style={{
          paddingRight: convertPxToRem(6.5),
          justifyContent: 'center',
          alignItems: 'flex-start'
        }}
      >
        <Flex vertical={true}>
          <div
            style={{
              font: 'normal normal 600 14px/18px Montserrat',
              color: '#677489'
            }}
          >
            {value1}
          </div>
          <div
            style={{
              font: 'normal normal 500 12px/15px Montserrat',
              color: '#677489'
            }}
          >
            {label1 ?? ''}
          </div>
        </Flex>
        <Flex vertical={true}>
          <div
            style={{
              font: 'normal normal 600 14px/18px Montserrat',
              color: '#677489'
            }}
          >
            {value2 ?? ''}
          </div>
          <div
            style={{
              font: 'normal normal 500 12px/15px Montserrat',
              color: '#677489'
            }}
          >
            {label2 ?? ''}
          </div>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default CountBoxSingle;
